import { BunkerBargeAlongsideData } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import PropTransformer from "../PropTransformer";
import StringToNumberPropTransformer from "../StringToNumberPropTransformer";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const BUNKER_BARGE_ALONGSIDE_DATA_TAG = 'BunkerBargeAlongsideData';
export default class BunkerBargeAlongsideParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.BUNKERING_STATION_ALONGSIDE, FIXED_PROTOCOL_CONTENT_TYPE_IDS.BUNKERING_STATION_ALONGSIDE, BUNKER_BARGE_ALONGSIDE_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            name: 'name',
            freeText: 'freeText',
            comOp: 'commenceOperation',
            typeFluid: 'typeOfFluid',
            quant: new StringToNumberPropTransformer('quantity'),
            unit: 'unit',
        };
    }
    createData(props) {
        return new BunkerBargeAlongsideData(props.name || '', props.commenceOperation, props.typeOfFluid, props.quantity, props.unit, props.freeText);
    }
}
//# sourceMappingURL=BunkerBargeAlongsideParser.js.map